export default __webpack_public_path__ + "static/media/download.f7dadb1c.svg";